import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(theme => ({
    textButton: {
        fontSize: '.8rem'
    }
}))

export default useStyles
